import React from 'react';
import { CircularProgress, Switch } from '@mui/material';
import { SettingRow } from './SettingRow';

export interface SettingSwitchProps {
  /** Stable id: the switch's own, and what its label points at. */
  id: string;
  /** What the setting is, said as the thing that happens when it is on. */
  label: string;
  /** What happens now, for the current position. Replaced by `error` when there is one. */
  description?: React.ReactNode;
  checked: boolean;
  onChange: (next: boolean) => void;
  /** Saving: the switch is held and a small spinner shows beside it. */
  busy?: boolean;
  disabled?: boolean;
  error?: string | null;
}

/**
 * One on/off setting, as a row: what it is and what it means on the left,
 * the switch on the right — the way the workspace's Features page lays them
 * out, so a setting always looks like a setting.
 */
export function SettingSwitch({
  id, label, description, checked, onChange, busy = false, disabled = false, error = null,
}: SettingSwitchProps) {
  return (
    <SettingRow label={label} htmlFor={id} description={description} error={error}>
      {busy ? <CircularProgress size={16} aria-label="Saving" /> : null}
      <Switch
        id={id}
        checked={checked}
        disabled={disabled || busy}
        onChange={(_event, next) => onChange(next)}
      />
    </SettingRow>
  );
}
